import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { SectionQuestionMappingEntity } from "../entities/section-question-mapping.entity";

@Injectable()
export class SectionQuestionMappingRepo extends Repository<SectionQuestionMappingEntity>{
    constructor(private dataSource: DataSource) {
        super(SectionQuestionMappingEntity, dataSource.createEntityManager());
    }
}